import React from 'react';

const JaluziSettings = React.memo(({
  activeTypeTab,
  jaluziExtras,
  setJaluziExtras,
  metalJaluziExtras,
  setMetalJaluziExtras,
  handleSaveSettings,
  isSavingSettings
}) => {
  const isAhsap = activeTypeTab === 'ahsapJaluzi';
  const extras = isAhsap ? jaluziExtras : metalJaluziExtras;
  const setExtras = isAhsap ? setJaluziExtras : setMetalJaluziExtras;

  return (
    <>
      <div className="settings-card" style={{ marginBottom: '20px' }}>
        <div className="settings-card-title">
          <i className="fas fa-cogs"></i>
          <h4>Motor Ayarları</h4>
          <button className="btn-save" onClick={() => handleSaveSettings()} disabled={isSavingSettings}>
            {isSavingSettings ? '...' : 'Kaydet'}
          </button>
        </div>
        <div className="settings-grid">
          <div className="form-group" style={{ marginBottom: 0 }}>
            <label>Motor Döviz Kuru</label>
            <select value={extras.motorCurrency} onChange={(e) => setExtras(p => ({ ...p, motorCurrency: e.target.value }))}>
              <option value="USD">USD</option>
              <option value="EUR">EUR</option>
              <option value="TRY">TRY</option>
            </select>
          </div>
          <div className="form-group" style={{ marginBottom: 0 }}>
            <label>Motor Ücreti</label>
            <input type="number" value={extras.motorPrice} onChange={(e) => setExtras(p => ({ ...p, motorPrice: e.target.value }))} />
          </div>
        </div>
      </div>

      <div className="settings-card" style={{ marginBottom: '20px' }}>
        <div className="settings-card-title">
          <i className={isAhsap ? "fas fa-sliders-h" : "fas fa-layer-group"}></i>
          <h4>{isAhsap ? "Ahşap" : "Metal"} Jaluzi Ek Ücretler (₺)</h4>
          <button className="btn-save" onClick={() => handleSaveSettings()} disabled={isSavingSettings}>
            {isSavingSettings ? '...' : 'Kaydet'}
          </button>
        </div>
        <div className="settings-grid">
          <div className="form-group" style={{ marginBottom: 0 }}>
            <label>{isAhsap ? "Zıgıl Sistem" : "Zıgıl Sistem (Adet)"}</label>
            <input type="number" value={extras.zigil} onChange={(e) => setExtras(p => ({ ...p, zigil: e.target.value }))} />
          </div>
          {!isAhsap && (
            <>
              <div className="form-group" style={{ marginBottom: 0 }}>
                <label>Redüktörlü Farkı (m2)</label>
                <input type="number" value={extras.reduktor} onChange={(e) => setExtras(p => ({ ...p, reduktor: e.target.value }))} />
              </div>
              <div className="form-group" style={{ marginBottom: 0 }}>
                <label>İki Cam Arası (Adet)</label>
                <input type="number" value={extras.ikiCamArasi} onChange={(e) => setExtras(p => ({ ...p, ikiCamArasi: e.target.value }))} />
              </div>
            </>
          )}
        </div>
      </div>
    </>
  );
});

export default JaluziSettings;
